// Lib
import { createAction } from 'redux-actions';

export const SelectOrganization = createAction('SELECT_ORGANIZATION');
export const UpdateOrganizations = createAction('UPDATE_ORGANIZATIONS');
export const UpdateOrganizationProfile = createAction(
  'UPDATE_ORGANIZATION_PROFILE',
);
